import {
    DocumentFilters,
    DocumentsResponse,
    PartnerCreditCardStatement,
} from './partnerDocuments';

export function mergeBillsAndCreditCardStatements(
    bills: DocumentsResponse,
    creditCardStatements: PartnerCreditCardStatement[],
): DocumentsResponse {
    return {
        documents: [...bills.documents, ...creditCardStatements],
        filter_options: bills.filter_options,
    };
}

export function canCreditCardStatementsMatchFilters(filters: DocumentFilters): boolean {
    if (filters.relations?.length) return false;
    if (filters.tags?.length) return false;

    const direction = filters.documentDirection;
    if (direction && direction !== 'all' && direction !== 'other') return false;

    const categories = filters.documentCategories;
    if (categories?.length && !categories.includes('credit_card_statement')) return false;

    return true;
}
